import React, { PureComponent } from 'react';
import PropType from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import uniqBy from 'lodash/fp/uniqBy';
import amplitude from 'amplitude-js/amplitude';
import apiService from '../../../utils/api/apiService';
import getActivityInfo from '../../../utils/activityHelpers/getActivityInfo';
import { CLICK_RECENT_ACTIVITY_LINK } from '../../../constants/amplitudeEvents';
import SimpleWorkoutItem from '../../../components/Workout/SimpleWorkoutItem';
import Loading from '../../../components/Loading/Loading';

export class RecentWorkoutsComponent extends PureComponent {
  static sendAmplitudeEvent(workout, placement) {
    const activityInfo = getActivityInfo(workout.activityId);
    amplitude.getInstance().logEvent(CLICK_RECENT_ACTIVITY_LINK, {
      Placement: placement,
      ActivityType: activityInfo && activityInfo.Key ? activityInfo.Key : 'Unknown',
      OwnerProfilePictureSet: workout.userPhoto ? 'Yes' : 'No',
      Distance: Math.round(workout.totalDistance / 100) * 100,
    });
  }

  static propTypes = {
    t: PropType.func,
  }

  static defaultProps = {
    t: (str) => str,
  }

  state = {
    workouts: [],
    loading: true,
  }

  componentDidMount() {
    apiService.get('images/public/within',
      {
        lowerlat: -50, lowerlng: -180, upperlat: 68, upperlng: 180, limit: 20,
      })
      .then((res) => Promise.all(
        uniqBy((item) => item.workoutKey)(res.payload)
          .slice(0, 5)
          .map((image) => apiService.get(`workouts/${image.workoutKey}/combined`))
      ).then((workoutResults) => this.setState(() => ({ workouts: workoutResults.map((workoutResult) => workoutResult.payload), loading: false }))));
  }

  render() {
    const { t } = this.props;
    const { workouts, loading } = this.state;
    return (
      <div className="container is-relative is-suunto has-large-gap is-fullhd">
        <h2 className="title is-2 is-size-3-mobile has-text-centered is-uppercase is-home-section-heading">{t('RECENT_ACTIVITIES')}</h2>
        {!loading && (
        <div className="columns is-multiline">
          {workouts[0]
          && (
          <Link
            onClick={() => RecentWorkoutsComponent.sendAmplitudeEvent(workouts[0], 1)}
            className="column is-12-tablet is-6-desktop"
            to={{
              pathname: `/${__BRAND__.workoutTerm}/${workouts[0].username}/${workouts[0].workoutKey}`,
              state: { fromRecentWorkouts: true },
            }}
          >
            <SimpleWorkoutItem workout={workouts[0]} t={t} />
          </Link>
          )}
          <div className="column is-12-tablet is-6-desktop">
            <div className="columns is-multiline">
              {workouts.length > 0 && workouts.slice(1, 5).map((workout, index) => (
                <Link
                  onClick={() => RecentWorkoutsComponent.sendAmplitudeEvent(workout, index + 1)}
                  className="column is-12-tablet is-6-desktop is-6-widescreen"
                  key={workout.key}
                  to={{
                    pathname: `/${__BRAND__.workoutTerm}/${workout.username}/${workout.workoutKey}`,
                    state: { fromRecentWorkouts: true },
                  }}
                >
                  <SimpleWorkoutItem workout={workout} t={t} />
                </Link>
              ))}
            </div>
          </div>
        </div>
        )}
        {loading && <Loading />}
      </div>
    );
  }
}
export default translate()(RecentWorkoutsComponent);
